import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

export default function AddModal(props) {
  const { 
    provisionId,
    provisionTitle,
    setProvisionTitle,
    provisionContent,
    setProvisionContent,
    
    onClickSave,
    onClickExit
    } = props;

  // textarea 자동 높이 조절 //
  const autoResizeTextarea = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  // (실시간) 약관 제목 변경 //
  function onChangeTitle (e) { 
    setProvisionTitle(e.target.value);
  };

  // (실시간) 약관 내용 변경) //
  function onChangeContent (e) { 
    setProvisionContent(e.target.value); 
  };

  // 저장하기 버튼 //
  const handleSaveClick = () => {
    const mergedProvision = {
      id : provisionId,
      isDefault: false,
      title : provisionTitle,
      text : provisionContent
    };

    onClickSave(mergedProvision);
  };



  return (
    <TopLevelWrapper>
      <Modal>
        <TopExplainWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#000000' hover='default'>약관 수정하기</Text>
        </TopExplainWrapper>

        <ContentWrapper>
          <ExplainBlock>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' hover='default'>약관 제목</Text>
          </ExplainBlock>
          <InputTitleBlock>
            <TitleInput
              placeholder={"제목을 입력해주세요"}
              value={provisionTitle}
              onChange={onChangeTitle}
            />

          </InputTitleBlock>

          <ExplainBlock>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' hover='default'>약관 내용</Text>
          </ExplainBlock>
          <InputContentBlock>
            <Input 
              placeholder={"내용을 입력해주세요"}
              value={provisionContent}
              onChange={onChangeContent}
              input={autoResizeTextarea}
            />
          </InputContentBlock>
        </ContentWrapper>

        <ButtonWrapper>
          <CanclelButton onClick={onClickExit}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#3E4148' hover='pointer'>취소</Text>
          </CanclelButton>
          <SaveButton onClick={handleSaveClick}>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='pointer'>저장하기</Text>
          </SaveButton>
        </ButtonWrapper>
      </Modal>
    </TopLevelWrapper>
  );
}

const startAnimation = keyframes`
  0% { opacity: 0; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  inset: 0;
  widght: 100%;
  height: 100%;

  z-index: 99;

  background-color: rgba(0, 0, 0, 0.45);

  animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const Modal = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;

  padding: 10px 20px;

  width: 590px;
  height: 490px;

  top: 50%;
  left: 50%;
  z-index: 100;

  border-radius: 10px;
  border: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.10);
  
  transition: all 0.3s ease-in-out;
  transform: translate(-50%, -50%);
`;

const TopExplainWrapper = styled.div`
  display: flex;

  height: 40px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 10px;

  width: 100%;
  height: 378px;
`;

const ExplainBlock = styled.div`
  display: flex;

  width: 100%;
  height: 37px;
`;

const InputTitleBlock = styled.div`
  display: flex;

  padding: 10px;

  width: calc(100% - 20px);
  height: 20px;

  border-radius: 10px;
  border: 1px solid #969696;
  background-color: #FFFFFF;
`;

const InputContentBlock = styled.div`
  display: flex;

  padding: 10px;

  width: calc(100% - 20px);
  height: 240px;

  border-radius: 10px;
  border: 1px solid #969696;
  background-color: #F9F9F9;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;

  margin-top: 16px;

  width: 100%;

  gap: 10px;
`;

const CanclelButton = styled.button`
  display: flex;

  justify-content: center;
  align-items: center;

  padding: 5px 16px;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  border: none;
  background-color: #F5F6F8;

  cursor: pointer;
`;

const SaveButton = styled.button`
  display: flex;

  justify-content: center;
  align-items: center;

  padding: 5px 16px;

  width: 100px;
  height: 40px;

  gap: 10px;

  border-radius: 10px;
  border: none;
  background-color: #5BD98A;

  cursor: pointer;
`;

//####################
//###### TEXT ########
//####################

const Text = styled.p`
  align-self: center;

  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;

const TitleInput = styled.input`
  align-self: flex-start;

  width: 100%;
  height: 100%;

  font-size: 14px;
  font-family: NotoSansKR-Regular;
  color: #000000;

  resize: none;
  overflow: hidden;

  border: none;
  outline: none;
  background-color: transparent;
`;

const Input = styled.textarea`
  align-self: flex-start;

  width: 100%;
  height: 100%;

  font-size: 14px;
  font-family: NotoSansKR-Regular;
  color: #000000;

  resize: none;
  overflow: visible;

  border: none;
  outline: none;
  background-color: transparent;
`;